export default __webpack_public_path__ + "static/media/longLoadingDescriptionThumbnail.ccfa0346.svg";